import { useQuery } from '@tanstack/react-query';
import { getAgreementsActive } from './agreements.service';

export const useGetAgreementsActive = (is_accept_agreement?: boolean) => {
  return useQuery({
    queryKey: ['agreements', 'active'],
    queryFn: async () => getAgreementsActive(),
    enabled: !is_accept_agreement,
  });
};
